import axios from "axios";
import { Toast } from "@douyinfe/semi-ui";
import { getLocalStorage } from "@utils/localstorage";
import { LoginEnum } from "@services/user/enum/user.enum";
import { store } from "@state/store";
import type { AxiosResponse, AxiosError } from "axios";
import { LoginResponseModel } from "@services/user/model/user.model";
import { Page } from "@services/common/model/page.model";
import { setLoginDialogVisible } from "@state/global/reducer";
import { API_HOST } from "@config/global.config";

export const axiosInstance = axios.create({
  baseURL: `${API_HOST}/api/`,
});

export const request = axios.create({
  baseURL: `${API_HOST}/api/`,
});

request.interceptors.request.use(
  function (config) {
    const loginInfo = getLocalStorage<LoginResponseModel>(LoginEnum.Token);
    if (loginInfo) {
      config.headers.Authorization = loginInfo.token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  function (response) {
    // eslint-disable-next-line
    const { data } = response;
    // eslint-disable-next-line

    return data;
  },
  function (error: AxiosError<Page<null>, any>) {
    // const { response } = error;
    // if (!response) {
    //   return;
    // }
    // const { data } = response;
    // const { code } = data;

    // if (code === 401) {
    //   const currentPath = location.pathname;
    //   removeLocalStorage(LoginEnum.Token);
    //   store.dispatch(removeToken());
    //   window.location.href = `/about?login=true&redirect=${encodeURIComponent(
    //     currentPath
    //   )}`;
    // }

    return Promise.reject(error);
  }
);

axiosInstance.interceptors.request.use(
  function (config) {
    const loginInfo = getLocalStorage<LoginResponseModel>(LoginEnum.Token);

    if (loginInfo) {
      config.headers.Authorization = loginInfo.token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response: AxiosResponse<Page<null>>) {
    const { data } = response;
    const { code, message } = data;
    if (code !== 200 && code !== 401) {
      Toast.error(message);
    }
    return data as any;
  },
  function (error: AxiosError<Page<null>, any>) {
    const { response } = error;
    if (!response) {
      return;
    }
    const { data } = response;
    const { code, message } = data;
    if (code !== 200 && code !== 401) {
      Toast.error(message);
    }

    if (code === 401) {
      store.dispatch(setLoginDialogVisible(true));
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
